import { render, staticRenderFns } from "./TransactionView.vue?vue&type=template&id=a90b51c8&scoped=true&"
import script from "./TransactionView.vue?vue&type=script&lang=js&"
export * from "./TransactionView.vue?vue&type=script&lang=js&"
import style0 from "./TransactionView.vue?vue&type=style&index=0&id=a90b51c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a90b51c8",
  null
  
)

export default component.exports